var _circle, _circle2, _path, _path2, _circle3, _circle4, _circle5, _path3, _path4, _ellipse, _circle6, _rect, _circle7, _rect2, _rect3, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoJobsIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 98,
    viewBox: "0 0 131 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.4851,
    cy: 44.9032,
    r: 44.9032,
    fill: "#EAF9FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.4853,
    cy: 44.9015,
    r: 35.0968,
    fill: "#C7DDF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7182 89.1726C59.5955 93.3863 53.8455 96.0014 47.4847 96.0014C39.8924 96.0014 33.1702 92.2756 29.0469 86.5527C27.0115 92.0684 21.7074 96.0014 15.4847 96.0014C7.5033 96.0014 1.03308 89.5312 1.03308 81.5498C1.03308 73.5684 7.5033 67.0982 15.4847 67.0982C19.0961 67.0982 22.3981 68.4229 24.9314 70.6129C26.2569 59.3331 35.8488 50.582 47.4847 50.582C55.3245 50.582 62.2365 54.5547 66.3174 60.5967C69.7153 57.8823 74.0234 56.2595 78.7105 56.2595C87.3589 56.2595 94.717 61.7845 97.4475 69.4974C99.529 68.2995 101.943 67.6143 104.517 67.6143C112.073 67.6143 118.251 73.5194 118.686 80.9668C119.5 80.6759 120.377 80.5175 121.291 80.5175C125.567 80.5175 129.033 83.9837 129.033 88.2595C129.033 92.5352 125.567 96.0014 121.291 96.0014C118.342 96.0014 115.778 94.3523 114.471 91.926C111.909 94.4464 108.395 96.0014 104.517 96.0014C99.7335 96.0014 95.5028 93.6351 92.9314 90.0093C89.3228 93.7062 84.2847 96.0014 78.7105 96.0014C72.727 96.0014 67.3612 93.3567 63.7182 89.1726Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03308 81.5498C1.03308 73.5684 7.5033 67.0982 15.4847 67.0982C19.0961 67.0982 22.3981 68.4229 24.9314 70.6128C26.2569 59.3331 35.8488 50.582 47.4847 50.582C55.3245 50.582 62.2365 54.5547 66.3174 60.5967C69.7153 57.8823 74.0234 56.2595 78.7105 56.2595C87.359 56.2595 94.717 61.7845 97.4475 69.4974C99.529 68.2995 101.943 67.6143 104.517 67.6143C112.073 67.6143 118.251 73.5194 118.686 80.9668C119.5 80.6759 120.377 80.5175 121.291 80.5175C125.567 80.5175 129.033 83.9837 129.033 88.2595",
    stroke: "#05587C",
    strokeWidth: 2.06618,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.3237,
    cy: 26.3218,
    r: 1.54839,
    stroke: "#002D40",
    strokeWidth: 1.54963
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.776,
    cy: 63.4854,
    r: 1.03226,
    stroke: "#002D40",
    strokeWidth: 1.54963
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0002,
    cy: 55.4827,
    r: 2.32258,
    stroke: "#002D40",
    strokeWidth: 1.54963
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7891 38.7078H36.6456M45.4198 34.255V29.9336",
    stroke: "#05587C",
    strokeWidth: 1.54963,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0917 35.1712L38.6704 31.75",
    stroke: "#05587C",
    strokeWidth: 1.54963,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.7421,
    cy: 93.678,
    rx: 26.0645,
    ry: 2.32258,
    fill: "#ABC0DC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1939,
    cy: 53.9362,
    r: 14.7097,
    fill: "#EAF9FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.3593,
    y: 60.2891,
    width: 28.7696,
    height: 10.2965,
    rx: 5.14824,
    transform: "rotate(45 75.3593 60.2891)",
    fill: "#002D40"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.2968,
    cy: 54.5063,
    r: 15.7451,
    transform: "rotate(45 62.2968 54.5063)",
    stroke: "#002D40",
    strokeWidth: 6.06162
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.4047,
    height: 2.13875,
    rx: 1.06937,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 67.4393 58.1487)",
    fill: "#05587C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12.4047,
    height: 2.13875,
    rx: 1.06937,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 65.9257 49.3752)",
    fill: "#05587C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6564 29.7771C60.2909 29.7771 60.8053 30.2917 60.8055 30.9261C60.8055 31.5607 60.291 32.0752 59.6564 32.0752C59.022 32.075 58.5074 31.5606 58.5074 30.9261C58.5076 30.2918 59.0221 29.7772 59.6564 29.7771ZM79.6536 37.1513C82.8022 40.2999 84.918 44.0939 85.9982 48.1087C86.1631 48.7215 85.8003 49.3525 85.1876 49.5174C84.5749 49.6821 83.9445 49.3186 83.7796 48.706C82.8011 45.0695 80.8852 41.6326 78.0288 38.7761C74.0423 34.7896 68.9217 32.6328 63.705 32.3037C63.0721 32.2636 62.5915 31.718 62.6313 31.085C62.6712 30.4517 63.2168 29.9699 63.8501 30.0098C69.6036 30.3727 75.2566 32.7542 79.6536 37.1513Z",
    fill: "#05587C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4862 67.9375L90.2057 79.657",
    stroke: "white",
    strokeWidth: 2.2998,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoJobsIllustration);
export default __webpack_public_path__ + "static/media/NoJobsIllustration.4c33a1570e929e36ec54cd65094495cc.svg";
export { ForwardRef as ReactComponent };